import React from 'react'
import { Text, View } from 'react-native'
import { reactionFlowLayout } from '../../lib/reactionFlow'
import { ChatMessageText } from './ChatMessageText'
import { flowReactionNode, useChatFlowSpans, type ChatFlowProps } from './chatFlowShared'

/** Separate text, reaction and timestamp columns shared by web and native. */
export function ChatFlowBody({ content, authorName, timestamp, leading, reactions, counts, compact }: ChatFlowProps) {
  const [width, setWidth] = React.useState(320)
  const spans = useChatFlowSpans(content, authorName)
  const layout = reactionFlowLayout(width, counts)
  return <View testID="chat-content-columns" onLayout={event => setWidth(event.nativeEvent.layout.width)}
    style={{ flex: 1, minWidth: 0, flexDirection: 'row', alignItems: 'center', gap: 8, paddingVertical: 4 }}>
    <View testID="chat-message-column" style={{ flex: 1, minWidth: 0, flexDirection: 'row', alignItems: 'flex-start', gap: compact ? 6 : 8 }}>
      {leading}
      <Text testID="chat-message-text" className="font-typed text-ink-soft" style={{ flex: 1, minWidth: 0, fontSize: compact ? 12 : 14, lineHeight: compact ? 16 : 20 }}>
        <ChatMessageText spans={spans} />
      </Text>
    </View>
    {counts.length > 0 && <View testID="chat-reaction-column" style={{ width: layout.width, flexShrink: 0, paddingVertical: 2 }}>
      {flowReactionNode(reactions, layout.columns)}
    </View>}
    <Text className="font-typed text-ink-soft" style={{ flexShrink: 0, fontSize: compact ? 10 : 11, lineHeight: compact ? 16 : 20, opacity: 0.7 }}>{timestamp}</Text>
  </View>
}
